/* eslint-disable semi */
/**
 * @module lib/UrlUtils
 */
import { getUrlHostName, isProductionUrl } from './utils/url';

export { isProductionUrl };

/**
 * TODO: temporary hack to test whether or not a string begins with http/https.
 * A completed method is in the works...
 *
 * @param {string} value The url to test
 * @returns {boolean} Will return true if the value is a valid absolute url
 */
export function isValidUrl(value: string): boolean {
  return /^http/.test(value);
}

/**
 * Determines if the value is a valid https url string.
 *
 * @param {string} value The url to test
 * @returns {boolean} Will return true if the value is a valid, secure uri
 */
export function isSecureUrl(value: string): boolean {
  return isValidUrl(value) && /^https/.test(value);
}

/**
 * Determines if the value is a valid image url, namely if it's a string with a protocol/
 * domain/path, or an absolute path. Intended to make sure img src isn't assigned a relative
 * path, or a value that can be interpreted as such, so we don't accidentally request the app
 * html again which can lead to csrftoken mismatch bugs.
 *
 * @param {string} value The url to test
 * @returns {boolean} Will return true if the value is an acceptable image url
 */
export function isValidImgUrl(value: string): boolean {
  return /^(https?:\/\/[^/]+)?\/.+/.test(value);
}

/**
 * Takes a valid url string and ensures that it is an ssl enabled http scheme.
 *
 * @param {string} value The url to convert to secure https scheme
 * @returns {string} The secure url, or, if not a valid url, the original value
 */
export function secureUrl(value: string): string {
  if (isValidUrl(value)) {
    return isSecureUrl(value) ? value : 'https' + value.slice(value.indexOf(':'));
  }
  return value;
}

export function getQueryParameters(state: $TSFixMe): $TSFixMe {
  return (
    state &&
    state.routing &&
    state.routing.locationBeforeTransitions &&
    state.routing.locationBeforeTransitions.query
  );
}
/**
 * Returns the top level domain name.
 *
 * @returns {string} Given a hostname with n-number of subdomains. It will return only the top level domain
 * @example "subdomain.subdomain.subdomain.example.com" will return "example.com"
 */
export function domainWithoutSubdomain(): string {
  return (
    getUrlHostName()
      .match(/\w+\.\w+$/g)
      ?.pop() || document.domain
  );
}
